

/**
 * @fileOverview GSN Controller
 * @modified 04/19/2017
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/GSNController',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener','views/GSNColumnView'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');
		var GlobalEventDispatcher = require('GlobalEventDispatcher');
		var GlobalResizeListener = require('GlobalResizeListener');
		var GSNColumnView = require('views/GSNColumnView');

		$debug('GSN Controller fired, use debug=mmmGSNController for debug output...');
		$debug('loading GSN Controller...', 'mmmGSNController');

		var GSNController = function(options){
			this.gsnMenu = $('#js-gsnMenu'); // Stores the primary navigation container element
			this.gsnLinkList = $('#js-gsnList'); // Stores container for level 1 link elements
			this.siteHD = $('#js-siteHd'); // Stores the header container element
			this.menuBtn = $('.js-gsnMenuBtn'); // Stores the menu button for tablet
			this.menuBtnMbl = $('.js-gsnMenuBtnMbl'); // Stores the menu button for mobile
			this.mobileGSN = ''; // Will contain the cloned navigation used specifically for mobile devices
			this.mobileLogoSrc = '/3m_theme_assets/themes/3MTheme/assets/images/unicorn/Logo_Mobile_Transparent.png'; // Default mobile menu logo, this is overridden by the theme/site config
			this.gsnLogo = $('.js-primaryLogo').clone().removeClass('MMM--isNotOnMobile'); // Clone the desktop logo for later use in the mobile menu
			this.gsnSearch = $('#js-searchBar').clone().attr('id', $('#js-searchBar').attr('id') + '_mobile'); // Clone the search bar for later use in mobile menu
			this.mobileSubGSNCopy = ''; // Stores the navigation sub-menu which is copied out to the mobile navigation
			this.menuLinks = []; // Stores level 1 and level 2 link elements
			this.gsnDropdowns = {}; // Stores the level 1 link elements for desktop
			this.gsnFeature = $('#js-gsnFeature'); // The primary navigation feature container element
			this.gsnFeatures = {}; // Stores the feature content elements from level 2 feature links
			this.dynamicMenu = ''; // This will store the "dynamic" elements of the mobile navigation (levels 1, 2 and 3), as opposed to static links (Help, Profile etc.)
			this.gsnSubMenus = {}; // Stores sub-menu content from level 1 link elements
			this.gsnColumns = []; // Stores bottom-level links that will be sorted into columns
			this.gsnOpen = false; // Tracks whether the menu is open or not
			this.openFirstMenu = true; // Tracks whether or not the first menu should be opened automatically
			this.skinnyNav = false; // Used by iconic brand sites to indicate that the navigation should use the minimal "skinny" version which does not have features and sublinks
			this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();
			this.globalResizeListener = GlobalResizeListener.getResizeListener();

			this.init();
		};

		GSNController.prototype.init = function(){
			var self = this;

			$debug('GSN Init...', 'mmmGSNController');
			//for accessibilty testing
			if (urlHash['t'] === 'ac'){
                $('body').addClass('accw');
            }

			this.mobileLogoSrc = this.getTransparentLogo(this.mobileLogoSrc); // Update the mobile transparent logo source to use theme/site config override

			$debug('Transparent Logo URL: ' + this.mobileLogoSrc, 'mmmGSNController');

			this.menuLinks = this.getMenuLinks(); // Gather up all the level 1 and level 2 link elements that have a sub-menu to show

			$debug('Initializing GSN Controller Module...', 'mmmGSNController');

			// If there is a GPN object in SETTINGS, override defaults
			if(typeof window.SETTINGS.GPN !== 'undefined'){
				// Disables the default feature of opening the first child menu in the GPN (for tablet and desktop only)
				if(typeof window.SETTINGS.GPN.openFirstMenu === 'boolean' && window.SETTINGS.GPN.openFirstMenu === false){
					this.openFirstMenu = false;

					$debug('Open first menu: ' + this.openFirstMenu, 'mmmGSNController');
				}

				// This positions the GPN relative to the parent link on desktop, used for iconics that do not have a menu that goes to the grandchild level
				if(typeof window.SETTINGS.GPN.skinnyNav === 'boolean' && window.SETTINGS.GPN.skinnyNav === true){
					this.skinnyNav = true;

					$debug('Skinny Navigation: ' + this.skinnyNav, 'mmmGSNController');

					this.gsnMenu.addClass('MMM--skinnyGPN');
				}
			}

			this.setupGSNColumns(this.gsnMenu.find('.MMM--columnListGSN')); // Loop through all feature content and look for content that should be broken into columns
			this.mobileGSN = this.buildMobileGSN(this.gsnMenu); // Build the mobile navigation container
			this.mobileSubGSNCopy = this.mobileGSN.find('.js-gsnMenuContainer').clone(true); // Capture the mobile navigation to be copied later to create additional mobile sub-menus
			//this.getGSNFeatures(); // feature elements are now initialized on click
			this.mobileGSN.find('.js-gsnMenuContainer').attr('id', 'js-gsnTop').addClass('js-gsnTop MMM--gsnPrimary'); // Add id and classes to mobile navigation
			this.initSubLinks(); // Loop through menuLink elements and register sub-menus
			this.initMobileLinks(); // Check for links that should act as direct links on mobile devices
			this.setActive(); // Set active state if applicable
			this.setupHandlers();
			this.deferredLink();// Check to see if the user clicked a link prior to loading and open that menu
            
            return this;
		};

		GSNController.prototype.setupHandlers = function(){
			var self = this;

			$debug('GSN setup handlers...', 'mmmGSNController');

			// Event Handlers for closing the navigation
            /*
                Since so many events are based on clicking anywhere on the page except for specific elements,
                we attach an event listener to the body and filter based on the clicked target element or parent element
            */
			$('body').on('click', function(event){
				if(self.gsnOpen && !self.gsnClick(event)){ // If the navigation is already open and the navigation wasn't clicked
					event.preventDefault();
					self.gsnHide(event, $(this)); // Hide the navigation
				} else{
					// Desktop GSN Link
					if($(event.target).hasClass('js-gsnLink') || $(event.target).parents('.js-gsnLink').length > 0){ // If the clicked element was a level 1 desktop link
						event.preventDefault();

						$debug('Desktop GSN Link Click...', 'mmmGSNController');

						var $target = $(event.target).hasClass('js-gsnLink') ? $(event.target) : $(event.target).parents('.js-gsnLink'); // Get the target for the click

                        // If the target is already active hide it, otherwise show
						if($(event.target).hasClass('MMM--isActive')){
							self.gsnHide(event, $target);
						} else{
							self.gsnShow(event, $target);
						}
					}

					// Tablet GSN Menu Button
					if($(event.target).hasClass('js-gsnMenuBtn') || $(event.target).parents('.js-gsnMenuBtn').length > 0){ // If the clicked element was the tablet GSN menu button
						event.preventDefault();

						$debug('Tablet GSN Menu Click...', 'mmmGSNController');

						self.gsnShow(event, $(event.target)); // Navigation is already established as closed based on previous condition, open the navigation
					}

					// Mobile GSN Menu Button
					if($(event.target).hasClass('js-gsnMenuBtnMbl') || $(event.target).parents('.js-gsnMenuBtnMbl').length > 0){ // If the clicked element was the mobile menu button
						event.preventDefault();

						$debug('Mobile GSN Menu Click...', 'mmmGSNController');

						self.gsnShow(event, $(event.target)); // Navigation is already established as closed based on previous condition, open the navigation
					}

					// Desktop + Tablet Feature Link
					if($(event.target).hasClass('js-navFeatureLink') || $(event.target).parents('.js-navFeatureLink').length > 0){ // If the clicked element was a navigation feature link
						//event.preventDefault(); //for accessibilty removed

						$debug('Desktop or Tablet GSN Feature Link Click...', 'mmmGSNController');

						if(!$(event.target).parent().hasClass('MMM--isActive')){
							self.gsnFeatureShow(event, $(event.target)); // If the target "feture" element isn't already open, then open it
						}

						//for accessibilty added focus to gsnSubMenu
						self.gsnMenu.find($('.MMM--gsnSubMenu')).focus();
					}

					// Tablet GSN Sub-Menu Link
					if(($(event.target).hasClass('js-subNavLink') || $(event.target).parents('.js-subNavLink').length > 0) && $getLayout() !== 'Mobile'){ // If the clicked element was sub-menu link and the layout is not mobile
						event.preventDefault();

						$debug('Tablet GSN Sub-Menu Click...', 'mmmGSNController');

						var $target = $(event.target).hasClass('js-subNavLink') ? $(event.target) : $(event.target).parents('.js-subNavLink'); // Get the click target

                        // If the sub-menu is already open then close the sub-nav and hide the feature element, otherwise show sub-menu
						if($target.hasClass('MMM--isActive')){
							self.gsnSubNavHide(event, $target);
							self.gsnFeatureHide(event, $target);
						} else{
							self.gsnSubNavShow(event, $target);
						}
					}

					// Tablet/Mobile Sub-Menu Link
					if($(event.target).hasClass('js-gsnMenuLink') || $(event.target).parents('.js-gsnMenuLink').length > 0){ // If the clicked element was a sub-menu link (this also covers mobile)
						event.preventDefault();

						$debug('Mobile GSN Menu Click...', 'mmmGSNController');

						self.gsnSubMenuShow(event, $(event.target)); // Show the sub-menu target
					}
				}
			});

			//for accessibilty using tabkey to navigate through MMM--gsnSubMenu
			$(this.gsnMenu.find($('.MMM--gsnSubMenu li:last-child ul.MMM--isOnDesktop-2-gsn li:last-child'))).keydown(function(e) {
			    var code = e.keyCode || e.which;

			    if (code === 9) {  // tab key 
			        //$msg('it works!' + $('#js-gsnFeature .MMM--columnListGSN').length);
			        $debug('Tab key pressed	...', 'mmmGSNController', 'mmmGSNController');
			        if(self.gsnMenu.find($('.MMM--gsnSubMenu.MMM--gsnSecondary.MMM--isActive li').hasClass('MMM--isActive'))) {
			        	self.gsnMenu.find($('.MMM--gsnSubMenu.MMM--gsnSecondary.MMM--isActive li.MMM--isActive')).next().attr('tabindex', '0');
			        	self.gsnMenu.find($('.MMM--gsnSubMenu.MMM--gsnSecondary.MMM--isActive li.MMM--isActive')).next().focus();
			    	} else {
			    		self.gsnMenu.find($('.MMM--gsnSubMenu.MMM--gsnSecondary.MMM--isActive li.MMM--isActive')).next().removeAttr('tabindex');
			    		//self.gsnMenu.find($('.MMM--gsnSubMenu.MMM--gsnSecondary.MMM--isActive li.MMM--isActive')).next().blur();
			    	}
			    }
			});

			//for accessibilty using escape key to close gsn Menu
			$(document).keyup(function(e) {
			  if (e.keyCode === 27) { // esc key
			  	$debug('Hide Navigation on esc key pressed	...', 'mmmGSNController');
			  	self.gsnHide(event, $(this)); // Hide the navigation
			  }
			});

			this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.clearMobileGSN.bind(this)); // Listen for context change and reset the mobile menu if it happens
			this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.positionNav.bind(this)); // On resize the navigation may need to be repositioned on desktop

			return this;
		};
        
        /*
            This function checks the global SETTINGS object for a
            transparent logo override.  It accepts only one argument
            of the default transparent logo image and will return
            the override logo from the SETTINGS object if one is
            present or it will return the default if one is not found.
        */

		GSNController.prototype.getTransparentLogo = function(defaultImg){
			var self = this,
				tLogo = defaultImg; // Return variable, default to the provided image

			if(!!window.SETTINGS.transparentLogo){ // If an override is present in the SETTINGS object, re-set tLogo to that
				tLogo = window.SETTINGS.transparentLogo
			} else{ // Otherwise attempt to guess the image URL
				var $checkImg = $('<img></img>'), // Create an image element
					imageBase = tLogo.substring(0, tLogo.indexOf('.')), // Start with the default logo's URL
					language = SETTINGS.LOCALE.substring(0, 2); // Get the current language

				$checkImg.on('error', function(){ // Create an error event listener
					$checkImg.off('error').attr('src', tLogo); // Resolve the error by reverting the logo URL to the default
				}).on('load', function(){ // Create an on load event listener, this should fire once errors have been resolved (if there are any to begin with)
					tLogo = $checkImg.attr('src'); // Configure the image src as the default logo URL
					self.transparentLogo = tLogo; // Update the transparentLogo property
					self.mobileGSN.find('.MMM--gsnLogo .MMM--isPrimary').attr('src', tLogo); // Since this is asynchonous, the logo may already be on the page, apply the tLogo source
				});

				$checkImg.attr('src', imageBase + '-' + language + '.png'); // Guess the logo URLbased on locale and configure the src, may trigger the error handler
			}
            
			return tLogo;
		};
        
        /*
            This is the general function for showing the primary navigation.
            It accepts two arguments: the click event that triggered this
            behavior and the element that was clicked
        */

		GSNController.prototype.gsnShow = function(event, $element){
			var self = this;

			$debug('GSN show...', 'mmmGSNController');

			this.clearMobileGSN(); // First clear the mobile GSN to reset it

			if($element.hasClass('js-gsnLink')){ // If the clicked element was a level 1 desktop link
				this.gsnNavShow(event, $element); // Show the navigation itself and pass the clicked level 1 link element
			}
			else { // Otherwise a desktop or tablet feature link was clicked
				if(this.gsnLinkList.find('.js-gsnLink:eq(0)').hasClass('MMM--isActive')){ // If the first sub-link is already active then hide the navigation
					this.gsnHide(event, this.gsnLinkList.find('.js-gsnLink:eq(0)'));
				} else{
					$debug('Open First GSN Link...', 'mmmGSNController');

					if(this.openFirstMenu && $('.js-gsnLink').length > 0){ // Only open first menu on tablet if set to true
						this.gsnShow(event, this.gsnLinkList.find('.js-gsnLink:eq(0)')); // Re-fire function with the first child link as the target element
					}
				}
			}

			// Tablet scenario
			this.menuBtn.addClass('MMM--isActive'); // Set the menu button to active
			this.menuBtn.parent().addClass('MMM--isActive'); // Set the menu button parent to active
			$(this.menuBtn.find('a').attr('href')).addClass('MMM--isActive'); // Set the menu button's target to active

			// Mobile scenario
			this.mobileGSN.addClass('MMM--isActive'); // Set the mobile navigation container to active
			$('#js-bodyWrapper').addClass('MMM--gsnEnabled'); // Set the body wrapper to active to it can update view accordingly

			if(this.skinnyNav && ($getLayout() === 'Desktop' || $getLayout() === 'Luxury')){ // If this is a skinny navigation menu we need to position the navigation on desktop and larger
				if($element && this.gsnMenu.offsetParent()){
					$debug('GPN offset left: ' + $element.offset().left-this.gsnMenu.offsetParent().offset().left, 'mmmGSNController');
                    
					this.gsnMenu.css({left:$element.offset().left - this.gsnMenu.offsetParent().offset().left}); // Offset the navigation based on the clicked link
				}
				else{
					$debug('No Element Present...', 'mmmGSNController'); // This is an error and should not occur normally
				}
			}

			// For some reason Asian character sets occasionally render the li height incorrectly on GPN show in IE
			// Workaround solution is to breifly set the height to 0 and then back to auto after a short delay
			if(!!window.navigator && (window.navigator.userAgent.indexOf('MSIE') > -1 || window.navigator.userAgent.indexOf('Trident') > -1)){
				$('.MMM--gsnSubMenu li').height(0); // Set the height to 0
				setTimeout(function(){$('.MMM--gsnSubMenu li').height('auto');}, 10); // After 10 milliseconds re-set the height to auto
			}

			this.gsnOpen = true; // Set navigation status to open
            
            return this;
		};
        
        /*
            This function hides the navigation.
            It accepts two arguments: the click event that triggered
            it to hide and the element that was clicked.
        */

		GSNController.prototype.gsnHide = function(event, $element){
			//Desktop scenario
			this.gsnNavHide(event, $element); // Hide the navigation element itself

			//Tablet scenario
			this.menuBtn.removeClass('MMM--isActive'); // Set the tablet menu button to inactive
			this.menuBtn.parent().removeClass('MMM--isActive'); // Set the tablet menu button parent to inactive
			this.gsnMenu.removeClass('MMM--isActive'); // Set the navigation menu itself to inactive

			//Mobile scenario
			this.mobileGSN.removeClass('MMM--isActive'); // Set the mobile navigation container to inactive
			$('#js-bodyWrapper').removeClass('MMM--gsnEnabled'); // Remove the active flag from the body wrapper container element

			this.gsnOpen = false; // Set the navigation status to closed
            
            return this;
		};
        
        /*
            This function shows the specific navigation elements.
            It accepts two arguments: the click even that triggered it
            to show and the element that was clicked.
        */

		GSNController.prototype.gsnNavShow = function(event, $element){
			var self = this,
				targId = $element.attr('href'), // The target ID of the element that will need to be shown
				$target = $(targId), // The target element to show
				openFirstFeature = true, // Assume that we open the first feature by default
				$tabletLink = self.gsnMenu.find('.js-subNavLink[href=' + $element.attr('href') + ']'), // Find the tablet link that opens the same navigation
				parentFeature = false; // Flag to say if the element has a direct static feature element

			if($(targId + '-WC').length > 0){ // Look for static feature content that goes with the target
				targId = targId + '-WC'; // Update the target ID to look for the static feature content
				$target = $(targId); // Update the target itself to match the static feature content
				parentFeature = true; // Set parentFeature flag to true
			}

			$debug('GSN Feature ID: ' + targId, 'mmmGSNController');

			if(!self.gsnMenu.hasClass('MMM--isActive')){ // If the navigation container element is not already active, set it to active
				self.gsnMenu.addClass('MMM--isActive');
			}

			this.gsnHideFeatures(); // Hide all feature content
			this.gsnActivateFeature(targId, $element, $target); // Active the target feature

			if(!this.openFirstMenu){ // Determine if the first menu should be opened automatically or not, set parameters accordingly
				openFirstFeature = false;
				parentFeature = false;
			} else{
				openFirstFeature = this.gsnFirstFeature(targId); // If the first feature should be opened, invoke function to retrieve it
			}

			$debug('Open first GSN Feature: ' + openFirstFeature, 'mmmGSNController');
			$debug('Open parent Feature: ' + parentFeature, 'mmmGSNController');

			if(openFirstFeature && !parentFeature){ // If there is a first feature and no parent feature to show
				if(self.gsnDropdowns[targId].contents.find('.js-navFeatureLink:eq(0)').length){ // Find first feature in the target navigation menu
					if(self.gsnDropdowns[targId].contents.find('.js-navFeatureLink:eq(0)').parent().hasClass('MMM--isActive')){ // If the first feature in the target navigation menu is active, then hide the child feature
						self.gsnFeatureHide(event, self.gsnDropdowns[targId].contents.find('.js-navFeatureLink:eq(0)'));
					} else{ // Otherwise show the first feature
						self.gsnFeatureShow(event, self.gsnDropdowns[targId].contents.find('.js-navFeatureLink:eq(0)'));
					}
				} else{ // Otherwise if no first feature is found in the target then hide all features
					self.gsnClearFeature();
				}
			} else if(parentFeature){ // If the parent itself has a feature show that
				self.gsnFeatureShow(event, $element);
			}

			// Open corresponding tablet menu
			self.gsnMenu.find('.js-subNavLink').each(function(){ // Loop through sub-nav links
				$(this).removeClass('MMM--isActive'); // Remove active class from all
				self.gsnSubNavHide(event, $(this)); // Hide each sub-nav
			});

			$tabletLink.addClass('MMM--isActive'); // Add active class to appropriate sub-nav link

			self.gsnSubNavShow(event, $tabletLink); // Show the appropriate sub-nav link
            
            return this;
		};
        
        /*
            This function hides all features at once.
            It accepts no arguments.
        */

		GSNController.prototype.gsnHideFeatures = function(){
			var self = this;

			$.each(self.gsnDropdowns, function(key, value){ // Loop through each navigation dropdown
				if(value.isActive){ // If it is active, remove active classes from links, content and set isActive property to false
					value.link.removeClass('MMM--isActive');
					value.contents.removeClass('MMM--isActive');
					value.isActive = false;
				}
			});

			return this;
		};
        
        /*
            This function sets a feature to active.
            It accepts three arguments: the target feature ID,
            the triggering element, and the target element.
        */

		GSNController.prototype.gsnActivateFeature = function(targId, $element, $target){
			if(!this.gsnDropdowns[targId]){ // If this feature has not already been registered in the gsnDropdowns property with its target ID as an identifier, register it
				this.gsnDropdowns[targId] = { // targetId serves as the unique identifier for this element
					link: $element, // Store the trigger element as the link
					contents: $target, // Store the element itself as the contents
					isActive: true // Set the isActive property to true
				}
			} else{ // Otherwise if it is already registered in the gsnDropdowns object set its isActive property to true
				this.gsnDropdowns[targId].isActive = true;
			}

			$element.addClass('MMM--isActive'); // Add active class to the trigger element
			$target.addClass('MMM--isActive'); // Add active class to target element

			return this;
		};
        
        /*
            This function returns whether or not the first feature needs to be opened.
            It accepts one argument: the target ID of the parent element that
            has been activated.
        */

		GSNController.prototype.gsnFirstFeature = function(targId){
			var openFirstFeature = true; // Default to open first feature automatically

			$.each(this.gsnFeatures, function(key, value){ // Loop through features
				if(value.isActive && value.navParent == targId){ // If current feature is active and matches the target ID then we do not need to open the first feature
					openFirstFeature = false;
				}
			});

			return openFirstFeature;
		}
        
        /*
            This function hides a specific sub-navigation.
            It accepts two arguments: the click event that triggered
            the navigation to hide and the element that was clicked.
        */

		GSNController.prototype.gsnNavHide = function(event, $element){
			var targId = $element.attr('href'), // Get the target ID of the triggering element
				$target = $(targId); // Get the target element based on target ID

			if(this.gsnMenu.hasClass('MMM--isActive')){ // If the navigation menu is active, then set it to inactive
				this.gsnMenu.removeClass('MMM--isActive');
			}

			$element.removeClass('MMM--isActive'); // Remove the active class from the triggering element
			$target.removeClass('MMM--isActive'); // Remove the active class from the target element
			this.gsnLinkList.find('.js-gsnLink.MMM--isActive').removeClass('MMM--isActive'); // Find active link and remove active class
			this.gsnClearFeature(); // Clear all features
            
            return this;
		};
        
        /*
            This function shows a sub-navigation.
            It accepts two arguments: the click even that triggered the
            sub-navigation to show and the triggering element.
        */

		GSNController.prototype.gsnSubNavShow = function(event, $element){
			var self = this,
				targId = $element.attr('href'), // Get the target ID from the triggering element
				$target = $(targId); // Get the target element based on target ID

			$debug('GSN Sub-navigation Click: ' + targId, 'mmmGSNController');
			$debug($target, 'mmmGSNController');

			// Close open sub-navigation menus first
			this.gsnMenu.find('.js-subNavLink').each(function(){ // Loop through each sub-navigation link
				$(this).removeClass('MMM--isActive'); // Remove active class
				self.gsnSubNavHide(event, $(this)); // Hide current element's sub-navigation
			});
			
			$('.js-gsnDynamic .MMM--isTransparent').removeClass('MMM--isTransparent'); // Remove transparency class from any parent elements if previous menu had only one child
			$('.MMM--gsnContainerDiv').removeClass('MMM--singleSubGSN'); // Also remove class to hide sub-navigation on desktop if previous menu had only one child
			$element.addClass('MMM--isActive'); // Add active class to triggering element

			if($target.find('.js-navFeatureLink').length === 1){ // If the target sub-navigation has only one child, open that directly
				$element.parent().addClass('MMM--isTransparent'); // Make the parent transparent to give the appearance of selection (without any state implications that come with MMM--isActive)
				$('.MMM--gsnContainerDiv').addClass('MMM--singleSubGSN'); // Add a class to the sub-navigation to hide on desktop (no need to show for only one child)
				targId = $target.find('.js-navFeatureLink').attr('href'); // Update the target ID to the only child element's target ID
				this.gsnFeatureShow(event, $target.find('.js-navFeatureLink')); // Fire the gsnFeatureShow event with the single child element

				$debug('Target sub-navigation has only one child, opening "' + targId + '" instead', 'mmmGSNController');
			} else{ // Otherwise behave normally and open sub-navigation
				$element.find('.MMM--icn_arrowRight').removeClass('MMM--icn_arrowRight').addClass('MMM--icn_arrowDown'); // Swap out arrow icon classes
				$target.parent().addClass('MMM--isActive'); // Add active class to target's parent element

				// Open Feature if applicable
				if($(targId + '-WC').length > 0){ // If there is a WCM content item that matches the target ID, open the trigger element's feature directly
					this.gsnFeatureShow(event, $element);
				}
			}
            
            return this;
		};
        
        /*
            This function hides a sub-navigation.
            It accepts two arguments: the click event that triggered
            the sub-navigation to hide and the triggering element.
        */

		GSNController.prototype.gsnSubNavHide = function(event, $element){
			var targId = $element.attr('href'), // Get the target ID from the triggering element
				$target = $(targId); // Get the target element from the target ID

			$element.removeClass('MMM--isActive'); // Remove active class from triggering element
			$element.find('.MMM--icn_arrowDown').removeClass('MMM--icn_arrowDown').addClass('MMM--icn_arrowRight'); // Swap out arrow icon classes
			$target.parent().removeClass('MMM--isActive'); // Remove active class from target parent element
            
            return this;
		};
        
        /*
            This function shows a navigation feature element.
            It accepts two arguments: the click event that triggered
            the feature to show and the triggering element.
        */

		GSNController.prototype.gsnFeatureShow = function(event, $element){
			var targId = !!$element.attr('href') ? $element.attr('href') : $element.parents('.js-navFeatureLink').attr('href'), //Get the target ID from the element itself if it has one, otherwise get it from the parent
				$target = $(targId); // Get the target element from the target ID

			$debug('GSN Feature Click: ' + targId, 'mmmGSNController');

			if($(targId + '-WC').length > 0){ // If the target has a WCM content item for a feature
				targId = targId + '-WC'; // Update the target ID to include the '-WC' suffix
				$target = $(targId); // Get the new target
			}

			this.gsnMenu.find('.js-navFeatureLink').parent().removeClass('MMM--isActive'); // Remove active class from all feature link parents
			$element.parent().addClass('MMM--isActive'); // Add active class to triggering element parent

			$.each(this.gsnFeatures, function(key, value){ // Loop through features
                $debug(value, 'mmmGSNController');
                
				if(value.isActive){ // If current feature is active
					value.parent.append(value.contents); // Append contents to the parent
					value.isActive = false; // Set to inactive
				}
			});

			if(!this.gsnFeatures[targId]){ // If the target feature has not been registered yet in the gsnFeatures object
				this.gsnFeatures[targId] = { // Register target feature based on its targId as a unique identifier
					parent: $target.parent(), // Capture parent element
					contents: $target, // Capture target element
					navParent: $element.parents('ul').attr('id'), // Capture navigation parent container
					isActive: true // Set to active
				}
			} else{ // Otherwise simply set isActive property to true
				this.gsnFeatures[targId].isActive = true;
			}

			if(!this.gsnFeature.hasClass('MMM--isActive')){ // If the feature is not already active, then give is active class
				this.gsnFeature.addClass('MMM--isActive');
			}

			this.gsnFeature.html($target); // Update feature contents with the target element

			//for accessibilty set the focus
			$target.attr('tabindex', '-1');
			$target.focus();

            return this;
		};
        
        /*
            This function hides navigation feature elements.
            It accepts two arguments: the click event that triggered
            the feature to hide and the triggering element.
        */

		GSNController.prototype.gsnFeatureHide = function(event, $element){
			var targId = $element.attr('href'), // Get the target ID from the triggering element
				$target = $(targId); // Get the target element based on target ID

			$.each(this.gsnFeatures, function(key, value){ // Loop through registered features
				if(value.isActive){ // If feature is active
					value.parent.append(value.contents); // Append content to parent element
					value.isActive = false; // Set isActive property to false
				}
			});

			$element.parent().removeClass('MMM--isActive'); // Remove active class from triggering element's parent
			this.gsnFeature.removeClass('MMM--isActive'); // Remove active class from feature container
            
            return this;
		};
        
        /*
            This function clears the entire feature section of the navigation.
            It does not accept any arguments.
        */

		GSNController.prototype.gsnClearFeature = function(){
			$.each(this.gsnFeatures, function(key, value){ // Loop through the registered features
				if(value.isActive){ // If the current feature is active
					value.parent.removeClass('MMM--isActive').append(value.contents); // Remove the active class from its parent element and append the contents to the parent
					value.isActive = false; // Set isActive property to false
				}
			});
            
            return this;
		};
        
        /*
            This function shows a navigation sub-menu.
            It accepts three arguments: the click even that triggered
            the sub-menu to show, the triggering element, and an optional
            backOverride to allow levels of the navigation to be skipped
            on mobile for sub-menus with only one child link.
        */

		GSNController.prototype.gsnSubMenuShow = function(event, $element, $backOverride){
			var targId = !!$element.attr('href') ? $element.attr('href') : $element.parents('.js-gsnMenuLink').attr('href'), // Get the target ID from the triggering element if it has one, otherwise look to the parent menu link
                childCount = 0; // Track the number of child links so we know if a level should be skipped on mobile

			$debug('GSN Sub-menu Click: ' + targId, 'mmmGSNController');
			$debug(this.gsnSubMenus[targId], 'mmmGSNController');
            
            childCount = this.getChildLinks(this.gsnSubMenus[targId]); // Get the updated child count for the target submenu
            
            $debug('Sub-menu has ' + childCount + ' children', 'mmmGSNController');

			if(childCount === 1){ // Check if there is only one legitimate link in the sub-menu
				if(this.gsnSubMenus[targId].find('.js-gsnDynamic .js-navFeatureLink').length === 1){ // If the resulting seb-menu has only one feature link, open that link directly
					this.skipLevel(event, targId, $backOverride, '.js-navFeatureLink'); // Skip the navigation level and preserve the back link override if it exists along with the feature link class to open
				}
				else if(this.gsnSubMenus[targId].find('.js-gsnDynamic .MMM--menuExpand:not(".MMM--menuBack")').length === 1){ // If the resulting sub-menu has only one menu expand, open that directly
					this.skipLevel(event, targId, $backOverride, '.MMM--menuExpand:not(".MMM--menuBack")'); // Skip the navigation level and preserve the back link override if it exists along with the menu expand class to open
				}
				// TODO: Determine what happens if the sub-menu has only one link that is a direct link
			} else{ // Otherwise behave normally and open the menu that was clicked
				this.mobileGSN.find('.js-gsnMenuContainer').removeClass('js-lastSelected'); // Remove last selected class for mobile navigation menu

				if(this.gsnSubMenus[targId].hasClass('MMM--isNotActive')){ // If the target submenu is specifically inactive
					this.mobileGSN.find('.js-gsnMenuContainer.MMM--isActive').addClass('js-lastSelected').removeClass('MMM--isActive'); // Find current active menu and add last-selected class then remove active class
				} else { // Otherwise if target submenu is not specifically inactive
					this.mobileGSN.find('.js-gsnMenuContainer.MMM--isActive').addClass('MMM--isNotActive js-lastSelected').removeClass('MMM--isActive'); // Find current active menu and add inactive and last-selected class then remove active class
				}

				this.gsnSubMenus[targId].removeClass('MMM--isNotActive').addClass('MMM--isActive'); // Remove inactive class and add active class to target submenu element
				this.mobileGSN.removeClass('MMM--gsnPrimaryContain MMM--gsnSecondaryContain MMM--gsnTertiaryContain'); // Remove primary/secondary/tertiary class from the mobile container

				if(this.gsnSubMenus[targId].hasClass('MMM--gsnPrimary')){ // If the sub-menu has the primary class, add that to the container
					this.mobileGSN.addClass('MMM--gsnPrimaryContain');
				} else if(this.gsnSubMenus[targId].hasClass('MMM--gsnSecondary')){ // If the sub-menu has thr secondary class, add that to the container
					this.mobileGSN.addClass('MMM--gsnSecondaryContain');
				} else{ // Otherwise add the tertiary class to the contianer
					this.mobileGSN.addClass('MMM--gsnTertiaryContain');
				}

				if($backOverride !== undefined && $backOverride !== null){ // If a new back link was passed, replace the current one with its href and text
					this.gsnSubMenus[targId].find('.js-gsnDynamic .MMM--menuBack').attr('href', $backOverride.attr('href')).html($backOverride.html());
				}
			}

			return this;
		};
        
        /*
            This function returns the number of direct child links for a submenu.
            It accepts one argument: the element which we need a child count for.
        */
        
        GSNController.prototype.getChildLinks = function($element){
            var childCount = 0; // Stores the child count, default 0
            
            childCount = $element.find('.js-gsnDynamic>li>.js-navFeatureLink, .js-gsnDynamic>li>.MMM--gsnMktLink, .js-gsnDynamic>li>span>.js-gsnMenuLink, .js-gsnDynamic>li>.MMM--menuExpand:not(".MMM--menuBack")').length; // Count the number of direct children that are not the back link
            
            return childCount;
        };

		/* 	
            This function is called when a sub-navigation menu has only one child
            to skip the parent menu and reduce clicks on mobile.
            It accepts four arguments: the click event that triggered the navigation
            change, the target element ID, an optional back link override element and
            a class selector for the type of navigation element that is being skipped.
		*/
        
		GSNController.prototype.skipLevel = function(event, targId, $backOverride, selector){
			var $backLink = this.gsnSubMenus[targId].find('.js-gsnDynamic>li>.MMM--menuBack').clone(), // Clone the target submenus back link
				$newEl = this.gsnSubMenus[targId].find('.js-gsnDynamic ' + selector); // Get the navigation element that we are skipping to

			targId = $newEl.attr('href'); // Get the target ID of the new element

			// If we've already skipped a level, we need to track that so we don't create a loop
			if($backOverride !== undefined){
				$backLink = $backOverride; // Update the back link with the one that was passed in if it exists
			}

			$debug('Sub-menu has only one child, opening "' + targId + '" instead', 'mmmGSNController');
			$debug(this.gsnSubMenus[targId], 'mmmGSNController');
			$debug('New back link href:', 'mmmGSNController');
			$debug($backLink, 'mmmGSNController');
            
			this.gsnSubMenuShow(event, $newEl, $backLink); // Re-invoke the method with the child element but maintain the original back link

			return this;
		};
        
        /*
            This function initializes the column view for navigation grandchild links on tablet and desktop.
            It accepts one argument: the collection of grandchild containers that will need to be split into
            columns.
        */

		GSNController.prototype.setupGSNColumns = function($columnLists){
			var self = this;

			$.each($columnLists, function(i){ // Loop through each column container
				self.gsnColumns[i] = new GSNColumnView($(this)); // Create a new GSNColumnView module for each column container
			});

			return this;
		};
        
        /*
            This function builds the mobile navigation container.
            It accepts one argument: the original navigation menu.
        */

		GSNController.prototype.buildMobileGSN = function($target){
			var self = this,
				$mobileGSNWrap = $('<div class="MMM--isOnMobile MMM--isNotOnTablet"></div>'), // Outermost wrapper for mobile navigation to ensure it only displays on mobile
				$mobileGSN = $('<div id="js-gsnMenu_mobile" class="MMM--gsnMenu MMM--gsnPrimaryContain" style="display: block;"></div>'), // Functional wrapper for mobile navigation
				$mobileGSNContainer = $('<div class="MMM--gsnContainer js-gsnContainer"></div>'), // Wrapper for the non-mesh portion of the navigation
				$mobileGSNMenu = $('<ul class="MMM--menuList MMM--isNotOnDesktop js-gsnMenuContainer"></ul>'), // Wrapper for the actual navigation elements (excluding search and logo)
				$mobileGSNLogo = $('<div class="MMM--gsnLogo"></div>'), // Wrapper for the mobile navigation menu logo
				$gsnDynamic = $('<ul class="MMM--gsnDynamic js-gsnDynamic"></ul>'), // Wrapper for the dynamic portion of the mobile navigation (links that change upon navigation)
				$gsnOverlay = $('<div class="MMM--gsnMesh"></div>'); // Wrapper for the mesh/trifecta backround that sits undernearth the mobile navigation menu

			$mobileGSNLogo.append(self.gsnLogo.clone().addClass('MMM--isNotPrimary')); // Append the secondary mobile navigation menu logo to the container
			$mobileGSNLogo.append(self.gsnLogo.attr('src', self.mobileLogoSrc).addClass('MMM--isPrimary')); // Append the primary mobile navigation menu logo to the container
			$mobileGSNContainer.prepend(self.gsnSearch).prepend($mobileGSNLogo).append($mobileGSNMenu); // Prepend the search bar and the logo to the mobile navigation container and append the mobile navigation menu itself
			$mobileGSN.prepend($mobileGSNContainer).append($gsnOverlay); // Prepend the mobile navigation container to the general container and append the mesh/trifecta container

            // Get dynamic links for the initial mobile navigation
			$target.find('.js-gsnDynamic>li').each(function(){ // Loop through direct children of the initial navigation
				var $gsnLi = $(this).clone(); // Clone child link

				$gsnLi.find('ul').remove(); // Remove any child link lists

				if($gsnLi.find('a').length || $gsnLi.hasClass('MMM--menuDivider')){ // Append any links and the menu divider to the initial dynamic navigation menu
					$gsnDynamic.append($gsnLi);
				}
			});

			$mobileGSNMenu.append($gsnDynamic); // Append the dynamic mobile navigation menu mobile navigation

            // Get non-dynamic (static) links for the initial mobile navigation
			$target.find('.js-gsnMenuContainer>li').each(function(){ // Loop through direct children of the navigation menu container (non-dynamic links)
				var $gsnLi = $(this).clone(); // Clone the child link

				$gsnLi.find('ul').remove(); // Remove any child link lists
				
				if($gsnLi.find('a').length || $gsnLi.hasClass('MMM--menuDivider')){ // Append any links and the menu divider to the initial static navigation menu
					$mobileGSNMenu.append($gsnLi);
				}
			});

			$mobileGSNWrap.append($mobileGSN); // APpend the entire mobile navigation to the top-level container
			$('#js-bodyWrapper').attr('data-mobileGSNLoaded', 'true').after($mobileGSNWrap); // Set a flag in the HTML to indicate that the mobile navigation is fully built
			self.eventDispatcher.publish('mobileGSNBuilt'); // Dispatch an event for mobileGSNBuilt
			$mobileGSN.find('.js-gsnMenuContainer:eq(0)').addClass('MMM--isActive'); // Add active class to inner navigation so that it is active when the menu is opened
			self.dynamicMenu = $mobileGSN.find('.js-gsnDynamic'); // Set the dynamicMenu property to the initial dynamic navigation

			return $mobileGSN;
		};
        
        /*
            This function gets all links that open submenus in the navigation.
            It does not accept any arguments.
        */

		GSNController.prototype.getMenuLinks = function(){
			var menuLinks = []; // Array to store the submenu links

			menuLinks = this.gsnMenu.find('.js-gsnMenuLink'); // Populate menuLinks array with link elements

			// Check to see if we need to add any class modifiers to the links at this stage
			$.each(menuLinks, function(){ // Loop through each link that was discovered
				var targId = $(this).attr('href'), // Get the target ID for the link
					$target = $(targId), // Get the target element based on target ID
					targetChildren = $target.find('li'), // Get the child links for the target element
					childCount = 0; // Default child count to 0

				$.each(targetChildren, function(){ // First check to see if the target is an empty menu
					if($(this).find('a.MMM--menuBack').length !== 1){ // Don't include mobile back links in the count
						childCount++;
					}
				});

				if($(this).hasClass('MMM--menuBack')){
					childCount++;
				}

				$debug('GSN child menu ' + targId + ' has ' + childCount + ' children...', 'mmmGSNController');

				if(childCount === 0){ // If the element has no children add an is-empty class
					$(this).parent().addClass('MMM--isEmpty');
				}
			});

			return menuLinks;
		};
        
        /*
            This function initializes the submenu links and registers them in the gsnSubMenus property.
            It does not accept any arguments.
        */

		GSNController.prototype.initSubLinks = function(){
			var self = this;

			$.each(self.menuLinks, function(){ // Loop through each submenu link element
				var targId = $(this).attr('href'), // Get the target ID from the submenu link
					$target = $(targId); // Get the target element based on target ID

				// Only add target child menu if it has children populated
				if(!self.gsnSubMenus[targId]){ // If there is no submenu with that target ID registered yet
					if($target.hasClass('js-gsnTop')){ // If the target is the element inidicating the top of the navigation
						self.gsnSubMenus[targId] = $target; // Register target element with unique identifier target ID
					} else{ // Otherwise build the submenu for that target ID and target element
						self.gsnSubMenus[targId] = self.gsnBuildSubMenu(targId, $target);
					}
				}
			});

			return this;
		};
        
        /*
            This function initializes the mobile links and modifies icon classes if needed.
            It does not accept any arguments.
        */

		GSNController.prototype.initMobileLinks = function(){
			var self = this;

			// If a GPN link has a mobileurl, then we want to treat this as a direct link instead of a menu link on mobile devices only
			this.mobileGSN.find('a').each(function(){ // Loop through all links in the mobile navigation
				if($(this).attr('mobileurl') !== undefined){ // If the link element has a mobileurl attribute
					$(this).attr('href', $(this).attr('mobileurl')).removeClass('js-gsnMenuLink').removeClass('js-subNavLink'); // Replace the href attribute and remove functional classes
					$(this).find('.MMM--icn_arrowRight').removeClass('MMM--icn_arrowRight').addClass('MMM--icn_arrowHollowRight'); // Also update the icon classes to use a hollow arrow
				}
			});

			return this;
		};
        
        /*
            This function builds extra submenus for the mobile navigation to create the sliding effect.
            It accepts two arguments: the target element ID and the target element itself.
        */

		GSNController.prototype.gsnBuildSubMenu = function(targId, $target){
			var self = this,
				$gsnSubMenuCopy = this.mobileSubGSNCopy.clone().attr('id', targId.substring(1, targId.length) + '_mobile').removeClass('MMM--isActive'); // Clone the origina submenu and update the ID to include the '_mobile' suffix so that it remains unique

			$gsnSubMenuCopy.find('.js-gsnDynamic').html($target.html()); // Update the copied submenu's dynamic content container with the target's HTML

			if($target.hasClass('MMM--gsnSecondary')){ // If the target is a secondary submenu add the secondary class
				$gsnSubMenuCopy.addClass('MMM--gsnSecondary');
			} else{ // Otherwise add the tertiary class
				$gsnSubMenuCopy.addClass('MMM--gsnTertiary');
			}

			this.mobileGSN.find('.js-gsnContainer').append($gsnSubMenuCopy); // Append the copied submenu element

			$gsnSubMenuCopy.find('.js-gsnMenuLink').each(function(){ // Look for submenu links within the new menu and add it to the registered list of submenu links
				self.menuLinks.push($(this));
			});

			return $gsnSubMenuCopy;
		};
        
        /*
            This function gets all navigation features and registers them in the gsnFeatures property.
            It does not accept any arguments.
        */

		GSNController.prototype.getGSNFeatures = function(){
			// Get Level 2 Feature Links
			$('.js-navFeatureLink').each(function(i){ // Loop through feature link elements
				var targId = $(this).attr('href').substring(1, $(this).attr('href').length), // Get the target ID from the link element
					$target = $('#' + targId); // Get the target element based on target ID

				this.gsnFeatures[targId] = { // Register the feature in the gsnFeatures property based on target ID as a unique identifier
					parent: $target.parent(), // Register the parent property with the target parent element
					contents: $target, // Register the contents property with the target element
					navParent: $(this).parents('ul').attr('id'), // Register the navParents property with the link element's parent ID
					isActive: true // set the feature to active
				}
			});

			// Get Level 1 Feature Links
			$('.js-gsnLink').each(function(i){ // Loop through top-level desktop links
				var targId = $(this).attr('href').substring(1, $(this).attr('href').length), // Get the target ID from the link element
					$target = $('#' + targId + '-WC'); // Get the target with the target ID and '-WC' suffix

				if($target.length > 0){ // Only add this to the object if the element with [targId]-WC ID exists
					this.gsnFeatures[targId] = { // Register the feature in the gsnFeatures property with the target ID as a unique identifier
						parent: $target.parent(), // Register the parent property with the target parent element
						contents: $target, // Register the contents property with the target element
						navParent: $(this).parents('ul').attr('id'), // Register the navParents property with the link element's parent ID
						isActive: true // set the feature to active
					}
				}
			});

			return this;
		};
        
        /*
            This function resets the mobile navigation for when the navigation changes when the mobile navigation is not currently open.
            It does not accept any arguments.
        */

		GSNController.prototype.clearMobileGSN = function(){
			this.mobileGSN.removeClass('MMM--gsnSecondaryContain MMM--gsnTertiaryContain').addClass('MMM--gsnPrimaryContain'); // Remove secondary and tertiary style classes and add primary style class

			$.each(this.gsnSubMenus, function(key, value){ // Loop through each submenu
				if(!value.hasClass('js-gsnTop') && value.hasClass('MMM--isActive')){ // If it is not a navigation top element and is currently active
					value.removeClass('MMM--isActive'); // Remove the active class
				} else if(value.hasClass('js-gsnTop') && !value.hasClass('MMM--isActive')){ // Otherwise if it is a navigation top element and is not active
					value.addClass('MMM--isActive'); // Add the active class
				}

				value.removeClass('js-lastSelected MMM--isNotActive'); // Remove the last-selected and inactive classes in all scenarios
			});

			return this;
		};
        
        /*
            This function detects if an event is in the context of the global navigation.
            It accepts one argument: the event that was captured.
            
            NOTE: This function is not currently used.
        */

		GSNController.prototype.gsnRollOff = function(event){
			screenSize = $getLayout();

			return (event.toElement.id !== 'js-gsnMenu' && $(event.toElement).parents('#js-gsnMenu').size() < 1 && (screenSize === 'Luxury' || screenSize === 'Desktop')); // Return true if the event was in the context of the global navigation and if the screen size is desktop or larger
		};
        
        /*
            This function detects if a click event is in the context of the global navigation.
            It accepts one argument: the click event that was captured.
        */

		GSNController.prototype.gsnClick = function(event){
			return ($(event.target).parents('#js-gsnMenu').length > 0 || $(event.target).parents('.js-gsnLink').length > 0 || $(event.target).hasClass('js-gsnLink') || $(event.target).parents('#js-gsnMenu_mobile').length > 0); // Return true if the click event is in the context of the global navigation or mobile navigation
		};
        
        /*
            This function positions the skinny navigation to sit underneath the clicked navigation link.
            It does not accept any arguments.
        */

		GSNController.prototype.positionNav = function(){
			var $activeGPNParent = ''; // Store the active navigation link that was clicked

			if(this.skinnyNav && $getLayout() === 'Tablet'){ // If skinny navigation is enabled and the current view is tablet
				$debug('Switched to tablet view, reset skinny navigation position...', 'mmmGSNController');

				this.gsnMenu.css({left: 0}); // Move the navigation menu all the way to the left for tablet always
			} else if(this.skinnyNav && ($getLayout() === 'Desktop' || $getLayout() === 'Luxury')){ // Otherwise if skinny navigation is enabled and the current view is desktop or larger
				$debug('Switched to desktop view, re-calculate skinny navigation position...', 'mmmGSNController');

				$activeGPNParent = $('.js-gsnLink.MMM--isActive'); // Get the active parent link that was clicked
				if ($activeGPNParent.length !== 0 && this.gsnMenu.offsetParent()){ // Get the offset position of the active parent link
					this.gsnMenu.css({left: $activeGPNParent.offset().left - this.gsnMenu.offsetParent().offset().left}); // Move the navigation to have its left value match the active link
				}
				else {
					$debug('No Active GSN Parent Present', 'mmmGSNController');
				}
				
			}

			return this;
		};

		/* 
            This function looks for an active link in the global navigation.
            It does not accept any arguments.
		*/
        
		GSNController.prototype.setActive = function(){
			var $selectedEl = this.gsnMenu.find('.isSelected'), // Find the selected navigation link
				navID = ''; // Stored the selected element ID

			if($selectedEl.length > 0){ // If an element is selected
				while($selectedEl.parents('.MMM--gsnSubMenu').length > 0){ // As long as the selected element has a submenu parent element
					navID = $selectedEl.parents('.MMM--gsnSubMenu').attr('id'); // Get the new parent submenu ID
					$selectedEl = $selectedEl.parents('.MMM--gsnSubMenu'); // Update the selected element to match the parent submenu ID
				}

				$('.js-gsnLink[href=#' + navID + ']').addClass('MMM--isSelected'); // After the while loop is completed add the isSelected class to the navigation element whose href matches the stored element ID
			}

			return this;
		};

		/*
            This function looks for a hash value in the URL and opend it if it matches a navigation menu item.
			Useful when the user clicks the GPN before the module has fully initialized.
            It does not accept any arguments.
		*/
        
		GSNController.prototype.deferredLink = function(){
			var windowHash = window.location.hash; // Get the URL hash value

			if(windowHash !== ''){ // If the URL has a has value
				if(this.gsnLinkList.find('a[href="' + windowHash + '"]').length > 0 && $(windowHash).length > 0){ // Search for both a link element whose href matches the hash as well as a target element that matches the hash
					this.gsnShow({}, $(windowHash)); // Show the navigation menu that matches the URL hash
				}
			}

			return this;
		};

        return GSNController;
    });

}(MMMRequire));